module.exports = __webpack_public_path__ + "static/media/step-two-small.ee142dbb.webp";